module.exports = __webpack_public_path__ + "static/media/trimex_saratoga.657251f8.png";